import { ProductDetails } from '../models/product';

/**
 * Converts Firebase Realtime Database keyed object to ProductDetails array.
 * Used when products are stored as { [id]: ProductDetails }.
 */
export const firebaseProductsToArray = (data: Record<string, ProductDetails>): ProductDetails[] => {
  const array: ProductDetails[] = [];
  for (const key in data) {
    array.push(data[key]);
  }
  return array;
};
